export default __webpack_public_path__ + "static/media/gallery6.4cf6b277.jpg";